module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/radiator-old-style/OldStyleRadiator.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/radiator-old-style/OldStyleRadiator.png
// module id = 612
// module chunks = 0